import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { FieldProps, useFieldHelper } from 'framework/ui/field';

interface ComplianceControlNameFieldProps extends FieldProps<string> {
  controlIdSource: string;
}

const ComplianceControlNameField = ({ source, controlIdSource }: ComplianceControlNameFieldProps) => {
  const { getValue: getName } = useFieldHelper<string | null>({ source });
  const { getValue: getControlId } = useFieldHelper<string>({ source: controlIdSource });
  const name = getName();
  const controlId = getControlId();

  return (
    <Stack>
      <Typography variant="body1">{name || controlId}</Typography>
      {name && (
        <Typography variant="caption" color="textSecondary">
          {controlId}
        </Typography>
      )}
    </Stack>
  );
};

export default ComplianceControlNameField;
